import { UploadButton } from '@bytescale/upload-widget-react';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { ProfilePicture } from 'components/common/ProfilePicture';
import React, { useEffect, useState } from 'react'
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { useDispatch, useSelector } from 'react-redux';
import { cdn } from 'constants/common';
import { setError } from 'slices/userSlice';
import toast from 'react-hot-toast';
import FullPageLoader from 'components/common/FullPageLoader';
import { fetchMainAccountProfile } from 'slices/mainAccount/mainAccountProfileSlice';
import { mainAccountProfileSelector } from 'slices/mainAccount/mainAccountProfileSlice';
import { updateMainAccountProfile } from 'slices/mainAccount/mainAccountProfileSlice';
import { IconButton, Switch } from '@mui/material';
import moment from 'moment';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { CustomSwitch } from 'components/common/Switch';
import TagInput from 'components/TagInput';
import EstimateDurations from 'components/accounts/MinDuration';
import { fetchStates } from 'slices/stateSlice';
import { Select } from 'components/common/Select';
import { stateSelector } from 'slices/stateSlice';
import { fetchCountries } from 'slices/countrySlice';
import { fetchTimezone } from 'slices/timezoneSlice';
import { USA } from "constants/common";
const ShowProfile = ({ item, handleEdit }) => {

    const InfoRow = ({ label, value }) => (
        <tr>
            <td className='col-3'><strong>{label}</strong></td>
            <td className='col-9'>{value || 'N/A'}</td>
        </tr>
    );

    const renderRates = (rate) => (
        <div key={rate.id}>
            <h2 className='fs-6'>
                {rate?.sub_client_tier[0]?.languages?.map((data) => data?.language?.name).join(', ') || 'Languages N/A'}
            </h2>
            <table>
                {[
                    ["OPI Normal Rate", rate.opi_normal_rate, rate.opi_normal_rate_time_unit, rate.opi_normal_mins],
                    ["VRI Normal Rate", rate.vri_normal_rate, rate.vri_normal_rate_time_unit, rate.vri_normal_mins],
                    ["In-Person Normal Rate", rate.inperson_normal_rate, rate.inperson_normal_time_unit, rate.inperson_normal_mins],
                    ["OPI After Rate", rate.opi_after_rate, rate.opi_after_rate_time_unit, rate.opi_after_mins],
                    ["VRI After Rate", rate.vri_after_rate, rate.vri_after_rate_time_unit, rate.vri_after_mins],
                    ["In-Person After Rate", rate.inperson_after_rate, rate.inperson_after_time_unit, rate.inperson_after_mins]
                ].map(([label, price, unit, mins]) => (
                    <InfoRow
                        key={label}
                        label={`${label} :`}
                        value={`$${price} / ${unit} (${mins} mins minimum duration)`}
                    />
                ))}
            </table>
        </div>
    );
    const renderCustomRates = (rate) => (
        <div key={rate?.id}>
            <h2 className='fs-6'>
                {rate?.custom_tier_languages?.map((data) => data?.language?.name).join(', ') || 'Languages N/A'}
            </h2>
            <table>
                {[
                    ["OPI Normal Rate", rate.opi_normal_rate, rate.opi_normal_rate_time_unit, rate.opi_normal_mins],
                    ["VRI Normal Rate", rate.vri_normal_rate, rate.vri_normal_rate_time_unit, rate.vri_normal_mins],
                    ["In-Person Normal Rate", rate.inperson_normal_rate, rate.inperson_normal_time_unit, rate.inperson_normal_mins],
                    ["OPI After Rate", rate.opi_after_rate, rate.opi_after_rate_time_unit, rate.opi_after_mins],
                    ["VRI After Rate", rate.vri_after_rate, rate.vri_after_rate_time_unit, rate.vri_after_mins],
                    ["In-Person After Rate", rate.inperson_after_rate, rate.inperson_after_time_unit, rate.inperson_after_mins]
                ].map(([label, price, unit, mins]) => (
                    <InfoRow
                        key={label}
                        label={`${label} :`}
                        value={`$${price} / ${unit} (${mins} mins minimum duration)`}
                    />
                ))}
            </table>
        </div>
    );
    return (
        <div className='container_main mt-4 profile-container'>
            <div className="profile-header">
                <div className="profile-image">
                    {/* <ProfilePicture imageUrl="/images/default-person.png" /> */}
                    <ProfilePicture imageUrl={item?.user?.image ? (cdn + item?.user?.image) : '/images/default-person.png'} />
                </div>
                <div className="profile-info">
                    <h1 className='text-capitalize'>{item?.user?.name}</h1>
                    <p>{item?.address}</p>
                    <div className="edit_prof">
                        <button type='button' className='main_button' onClick={handleEdit}>
                            <i className="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;
                            <span>Edit Profile</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="profile-section">
                <h2>Personal Information</h2>
                <table>
                    <InfoRow label="Name:" value={item?.user?.name} />
                    <InfoRow label="Email:" value={item?.user?.email} />
                    <InfoRow label="Cell Phone:" value={item?.phone} />
                    {/* <InfoRow label="Role:" value="User" /> */}
                    <InfoRow label="Timezone:" value={item?.timezone?.display_name} />
                </table>
            </div>

            <div className="profile-section">
                <h2>Billing Information</h2>
                <table>
                    {item?.billing_person && <InfoRow label="Contact Person Name:" value={item?.billing_person} />}
                    <InfoRow label="Email :" value={item?.billing_email} />
                    <InfoRow label="Select State:" value={item?.state?.name} />
                    <InfoRow label="City Name:" value={item?.billing_city_name} />
                    <InfoRow label="Zip Code:" value={item?.billing_zipcode} />
                    <InfoRow label="Invoicing Period:" value={item?.invoicing_period} />
                </table>
            </div>

            <div className="profile-section">
                <h2>Professional Information</h2>
                <table>
                    <InfoRow label="Facilities:" value={item?.facilities?.map(f => f?.facility_name).join(', ')} />
                    <InfoRow label="Departments:" value={item?.departments?.map(d => d?.department_name).join(', ')} />
                    <InfoRow label="Sub users:" value={item?.sub_accounts?.map(s => s?.subaccount_name).join(', ')} />
                </table>
            </div>

            <div className="profile-section">
                <h2>Interpretation Rates</h2>
                {item?.interpretation_rates?.length > 0
                    ? item.interpretation_rates.map(renderRates)
                    : <p>N/A</p>}
            </div>

            <div className="profile-section">
                <h2>Custom Interpretation Rates</h2>
                {item?.custom_tier?.length > 0
                    ? item.custom_tier.map(renderCustomRates)
                    : <p>N/A</p>}
            </div>
        </div>
    );
};

const BillingInfo = ({ item, setfilterStates, dispatch, setAllStates, states, control, error, filterStates, allStates, errors }) => {

    // #region States dropdown
    useEffect(() => {
        dispatch(fetchStates(1, { id: item?.state?.id }))
        if (item?.state?.name && item?.state?.id) {
            setfilterStates({
                label: item?.state?.name || "",
                value: item?.state?.id || ""
            })
        } else {
            setfilterStates(null)
        }
    }, [item?.state])


    const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        setAllStates(result?.data)
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    // #region City dropdown
    const [allCities, setAllCities] = useState([])
    const [selectedCity, setSelectedCity] = useState({
        label: "",
        value: ""
    })
    const filteredCities = React.useMemo(() =>
        allCities?.map(city => {
            const object = {
                label: city?.name || '',
                value: city?.id || '',
            }
            return object
        }), [allCities, item?.city]);


    const filteredStates = React.useMemo(() => {

        setAllCities(item?.state?.name != null ? states?.find(state => state?.name == item?.state?.name)?.cities : [])
        return states?.map(item => {
            const object = {
                label: item?.name,
                value: item?.id,
            }
            return object
        })
    }, [states, item?.state?.name]);

    useEffect(() => {
        setSelectedCity(filteredCities)
    }, [filteredCities])

    useEffect(() => {
        if (item?.city?.name && item?.city?.id) {
            setSelectedCity({
                label: item?.city?.name || "",
                value: item?.city?.id || ""
            })
        } else {
            setSelectedCity(null)
        }
    }, [item?.city])

    //#endregion

    const invoiceOption = [
        {
            label: "Weekly",
            value: "weekly",
        },
        {
            label: "Bi-weekly",
            value: "bi-weekly",
        },
        {
            label: "Monthly",
            value: "monthly",
        }
    ]
    return (
        <div className='w-100 biling_info'>
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>Biling information </h2>
            </div>
            <div className='foam_page_row'>

                <div className="row-primary">
                    <h2>Email *</h2>
                    <div className='w-100'>
                        <Controller name="billing_email" control={control} rules={{ required: true, }}
                            render={({ field }) => <input className={`input-in type_inp ${error?.errors?.billing_email ? "border-red" : ""} `} type="email" autoComplete="off" name='billing_email'
                                pattern={
                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                }
                                placeholder="Email Address"
                                {...field} />
                            }
                        />
                        {error?.errors?.billing_email?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                    </div>
                </div>

                <div className="row-primary">
                    <h2>Contact Person Name</h2>
                    <div className='w-100'>
                        <Controller name="billing_person" control={control} render={({ field }) => <input className="input-in type_inp" type="text" name='billing_person' placeholder='Name' {...field} />} />
                        {error?.errors?.name?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                    </div>
                </div>

                <div className="row-primary">
                    <h2>Select State *</h2>

                    <Controller
                        name="billing_state_id"
                        control={control}
                        rules={{
                            required: "Please select a state"
                        }}
                        render={({ field }) =>
                            <div style={{ width: "100%" }}>
                                <AsyncPaginate
                                    menuPlacement='auto'
                                    styles={{
                                        ...selectCustomStyles,
                                    }}
                                    value={filterStates}
                                    loadOptions={filteredStatesLoadOptions}
                                    isClearable
                                    escapeClearsValue
                                    onChange={(obj) => {
                                        setfilterStates(obj)
                                        setAllCities(obj != null ? allStates?.find(states => states?.name == obj?.label)?.cities : [])
                                        field.onChange(obj?.value);
                                    }}
                                    additional={{
                                        page: 1,
                                    }}
                                />
                                {errors?.billing_state_id?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.billing_state_id?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>

                <div className="row-primary">
                    <h2>City Name *</h2>
                    {/* <Controller name="billing_city_id" control={control} rules={{ required: "Please select a City" }}
                        render={({ field }) =>
                            <div style={{ width: "100%" }}>
                                <Select name="billing_city_id" options={filteredCities || []} {...field} value={filterStates ?? item?.city ? (filteredCities?.find((opt) => field.value === opt.value) || []) : null} />
                                {errors?.billing_city_id?.message && <div style={{ marginBottom: 10 }}> <ErrorMessage text={errors?.billing_city_id?.message} /> </div>}
                            </div>
                        }
                    /> */}

                    <Controller
                        name="billing_city_name"
                        control={control}
                        render={({ field }) => (
                        <div className="w-100">
                            <input
                            className="input-in type_inp"
                            type="text"
                            name="billing_city_name"
                            placeholder="Enter City Name"
                            {...field}
                            />
                            {errors?.billing_city_name?.message && (
                            <div style={{ marginBottom: 10 }}>
                                <ErrorMessage text={errors?.billing_city_name?.message} />
                            </div>
                            )}
                        </div>
                        )}
                    />

                </div>

                <div className="row-primary">
                    <h2>Zip Code *</h2>
                    <Controller name="billing_zipcode" control={control} render={({ field }) => <input className="input-in type_inp" type="text" name='billing_zipcode' required placeholder="Zip Code" {...field} />} />
                </div>

                <div className="row-primary">
                    <h2>Invoicing Period *</h2>
                    <div className='w-100'>
                        <Controller
                            name="invoicing_period"
                            rules={{
                                required: "Please select one"
                            }}
                            control={control}
                            render={({ field }) =>
                                <div className='select_box' style={{ width: "100%" }}>
                                    <Select
                                        name="invoicing_period"
                                        options={invoiceOption || []}
                                        value={field.value ? invoiceOption?.find((opt) => field.value == opt.value) : ""}
                                        isClearable={false}
                                        disabledSearch={true}
                                        onChange={(value) => {
                                            field.onChange(value);
                                        }}
                                    />
                                </div>
                            }
                        />
                        {errors?.invoicing_period?.message &&
                            <div style={{ marginBottom: 10 }}>
                                <ErrorMessage text={errors?.invoicing_period?.message} />
                            </div>
                        }
                    </div>
                </div>

            </div>
        </div>
    )
}

const FilterSwitch = ({ item, setValue }) => {

    const { control } = useFormContext();

    const fields = [
        { label: "US Based Interpreter", name: "us_based", lockName: "us_based_locked" },
        { label: "Non US Based Interpreter", name: "non_us_based", lockName: "non_us_based_locked" },
        { label: "English To Target Language", name: "english_to_target", lockName: "english_to_target_locked" },
        { label: "Spanish To Target Language", name: "spanish_to_target", lockName: "spanish_to_target_locked" },
        { label: "Court Certified", name: "court_certified", lockName: "court_certified_locked" },
        { label: "Medical Certified", name: "medical_certified", lockName: "medical_certified_locked" },
    ];

    const [localLockStates, setLocalLockStates] = useState({});

    useEffect(() => {
        if (item?.filters) {
            const initialLocks = {};
            fields.forEach((field) => {
                initialLocks[field.name] = item.filters[field.lockName] === 1;
            });
            setLocalLockStates(initialLocks);
        }
    }, [item]);

    const toggleLock = (name, lockName) => {
        setLocalLockStates((prev) => {
            const updated = { ...prev, [name]: !prev[name] };
            setValue(lockName, updated[name] ? 1 : 0); // form mein value set karo
            return updated;
        });
    };

    const handleChangeSwitch = (value, onChange) => {
        onChange(value);
    };

    return (
        <>
            <div className="row-primary row-r justify-content-between flex-row">
                <h2 className='fst-italic'>Filters</h2>
            </div>
            <div className='Filter_wrapper'>
                {fields.map((field) => (
                    <div key={field.name} className={`row-primary ${localLockStates[field.name] ? "lock_row" : ""}`}>
                        <h2 className="col-6">{field.label}</h2>
                        <Controller
                            control={control}
                            name={field.name}
                            render={({ field: controllerField }) => (
                                <div className="switch_row">
                                    <Switch
                                        className={localLockStates[field.name] ? "lockSwitch" : ""}
                                        checked={controllerField.value === 1}
                                        onChange={() => handleChangeSwitch(controllerField.value === 1 ? 0 : 1, controllerField.onChange)}
                                        color="primary"
                                        disabled={localLockStates[field.name]}
                                    />
                                </div>
                            )}
                        />
                        <button
                            onClick={() => toggleLock(field.name, field.lockName)}
                            type="button"
                            className={`field_locker ${localLockStates[field.name] ? "itslocked" : ""}`}
                        >
                            <i className={`fa-solid ${localLockStates[field.name] ? "fa-lock" : "fa-unlock"}`}></i>
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

const Profile = () => {
    const dispatch = useDispatch();
    const minDurations = [
        {
            id: 1,
            min_duration: 15,
            language_id: [],
            start_time: moment(new Date, ["h:mm A"]).format("HH:mm"),
            end_time: moment(new Date, ["h:mm A"]).add(15, "minutes").format("HH:mm"),
        }
    ]
    const methods = useForm({
        defaultValues: {
            minDurations
        }
    });

    const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, resetField } = methods;
    const { mainAccountProfile: item, error, loader } = useSelector(mainAccountProfileSelector);

    const [noOfVariants, setNoOfVariants] = useState([
        {
            field: '',
            required: 0
        }
    ]);
    const [activeEdit, setActiveEdit] = useState(false)
    const [credentialsSend, setCredentialsSend] = useState(0);
    const [notification, setNotification] = useState(0);
    const [localImage, setLocalImage] = React.useState('')
    const [lockStates, setLockStates] = useState({});
    const [allStates, setAllStates] = useState([]);
    const [filterStates, setfilterStates] = useState({
        label: "",
        value: ""
    })

    const { state: states } = useSelector(stateSelector);
    useEffect(() => {
        Promise.allSettled(
            [dispatch(fetchMainAccountProfile()),]
        )
    }, [])

        const [allCountries, setAllCountries] = useState([]);
        const [filterCountries, setfilterCountries] = useState({
        label: "",
        value: ""
        })
        const [availableTimezones, setAvailableTimezones] = useState([]);
        const [filterTimezones, setFilterTimezones] = useState({
        label: "",
        value: ""
        })
        const [timezoneDisable, setTimezoneDisable] = useState(false);

        const country_name = filterCountries?.label || '';

        const country_id = filterCountries?.value || '';
        const state_id = watch("state_id") ?? item?.state_id;
        
    useEffect(() => {
        setValue('name', item?.user?.name || '');
        setValue('email', item?.user?.email || '');
        setValue('phone', item?.phone || '');
        setValue('facility_names', item?.facilities?.map(i => i.facility_name) || []);
        setValue('department_names', item?.departments?.map(i => i.department_name) || []);
        setValue('subaccount_names', item?.sub_accounts?.map(i => i.subaccount_name) || []);

        setValue('us_based', item?.filters?.us_based || 0)
        setValue('non_us_based', item?.filters?.non_us_based || 0)
        setValue('english_to_target', item?.filters?.english_to_target || 0)
        setValue('spanish_to_target', item?.filters?.spanish_to_target || 0)
        setValue("medical_certified", item?.filters?.medical_certified || 0);
        setValue("court_certified", item?.filters?.court_certified || 0);

        setValue('us_based_locked', item?.filters?.us_based_locked || 0)
        setValue('non_us_based_locked', item?.filters?.non_us_based_locked || 0)
        setValue('english_to_target_locked', item?.filters?.english_to_target_locked || 0)
        setValue('spanish_to_target_locked', item?.filters?.spanish_to_target_locked || 0)
        setValue("medical_certified_locked", item?.filters?.medical_certified_locked || 0);
        setValue("court_certified_locked", item?.filters?.court_certified_locked || 0);

        setValue('billing_email', item?.billing_email || '');
        setValue('billing_person', item?.billing_person || '');
        setValue('billing_city_name', item?.billing_city_name || '');
        setValue('billing_zipcode', item?.billing_zipcode || '');
        setValue('billing_state_id', item?.state?.id || '')
        setValue('billing_city_id', item?.city?.id || '');
        setValue('invoicing_period', item?.invoicing_period || '')
        setValue('timezone_id', item?.timezone_id || '')

        const temp_array = [];
        setValue("dynamic_fields", item?.dynamic_fields?.map(p => {
            temp_array.push({
                field: p?.name,
                id: p?.id,
                required: p?.required,
            })
            return p?.name
        }));

        temp_array?.length > 0 ? setNoOfVariants(temp_array) : setNoOfVariants([{ field: "", id: 1, required: 0 }])

        setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 0);
        setNotification((typeof (item?.user?.notifications) == "number") ? item?.user?.notifications : 0);

        dispatch(setError({}));

    }, [item, activeEdit, setValue])


    
     // #region Timezone dropdown
    
      useEffect(() => {
        const fetchAndSetUSA = async () => {
          const result = await dispatch(fetchCountries(1, { search: USA }, true, true));
          const countries = result?.data || [];
          const usa = countries.find(c => c.name === USA);
          if (usa) {
            setfilterCountries({
              label: usa.name,
              value: usa.id,
            });
          }
        };
    
        fetchAndSetUSA();
      }, []);
    
    
    
      useEffect(() => {
        setFilterTimezones({
          value: item?.timezone?.id,
          label: item?.timezone?.display_name,
        });
      }, [item?.timezone]);
    
    
    
      // Load options function (API call to timezone endpoint)
      const filteredTimezonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const country_id = filterCountries.value;
    
        const result = await dispatch(
          fetchTimezone(
            page,
            {
              pageLength: 10,
              sortBy: "id",
              sortDirection: "asc",
              search: inputValue,
              country_id: country_id,
            },
            true,
            true
          )
        );
    
        return {
          options: result.data.map(val => ({
            value: val.id,
            label: val.display_name,
          })),
          hasMore: page !== result?.last_page,
          additional: {
            page: page + 1,
          },
        };
      };
    
    
    
      //#endregion

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            dispatch(fetchMainAccountProfile())
            handleCancelEdit()
        }
        else {
            console.log('onSubmit', error)
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const onSubmit = (data) => {
        dispatch(setError({}))
        const newData = {
            ...data,
            credentialsSend,
            notification,
        };

        dispatch(updateMainAccountProfile(newData, submitCallback));
    }

    const options = {
        apiKey: "free",
        maxFileCount: 1
    };

    //#region Dynamic fields
    const handleAdd = React.useCallback(() => {
        const newVariants = [...noOfVariants];
        newVariants.push({
            field: "",
            id: newVariants.length + 1,
            required: false,
        });
        setNoOfVariants(newVariants);
    }, [noOfVariants]);

    const handleRemove = React.useCallback((index) => {
        const newVariants = [...noOfVariants];
        newVariants.splice(index, 1);
        setNoOfVariants(newVariants);
    }, [noOfVariants]);

    const toggleRequired = (index) => {
        const newVariants = [...noOfVariants];
        newVariants[index].required = !newVariants[index].required;
        setNoOfVariants(newVariants);
    };

    useEffect(() => {
        setValue('dynamic_fields', noOfVariants?.map((variant) => variant.field));
        setValue('dynamic_fields_required', noOfVariants?.map((variant) => variant.required ? 1 : 0));
    }, [noOfVariants, setValue]);

    const renderDynamicField = React.useCallback((variant, index) => {
        return (
            <>
                <div className="row-primary mb-0 align-items-center mt-2" key={variant?.id} id={variant?.id}>
                    <Controller
                        name={`dynamic_fields[${index}]`}
                        rules={{ required: "Field is required", }}
                        control={control}
                        render={({ field }) => (
                            <input className="input-in type_inp" type="text" placeholder="" value={variant?.field}
                                onChange={(e) => {
                                    const newVariants = [...noOfVariants];
                                    newVariants[index].field = e.target.value;
                                    setNoOfVariants(newVariants);
                                }} />)}
                    />
                    {noOfVariants?.length > 1 && (
                        <IconButton color="error" onClick={() => handleRemove(index)}>
                            <i className="fa-solid fa-trash-can trash_icon"></i>
                        </IconButton>
                    )}
                    <div className="col-1">
                        <h2 className="fst-italic mt-0">Required</h2>
                        <Switch name={`dynamic_fields_required[${index}]`} checked={variant.required} onChange={() => toggleRequired(index)} color="primary" />
                    </div>
                </div>
                {errors?.dynamic_fields?.[index]?.message && (
                    <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors.dynamic_fields[index].message} />
                    </div>
                )}
            </>
        );
    }, [noOfVariants]);
    //#endregion


    function handleEdit() {
        dispatch(fetchMainAccountProfile())
        setActiveEdit(true)
    }
    function handleCancelEdit() {
        dispatch(fetchMainAccountProfile())
        setActiveEdit(false)
    }

    return (
        <div className="content">
            <div className="row_main_head">
                <h2 className="main_heading">Profile Page</h2>
            </div>
            {activeEdit === false ?
                <ShowProfile item={item} handleEdit={handleEdit} />
                :
                <div className='container_main mt-4'>
                    <FormProvider {...methods}>
                        <form className='profile_form' onSubmit={handleSubmit(onSubmit)}>

                            {/* Main credientials area  */}
                            <div className='foam_page_row'>
                                <div className="row-primary">
                                    <h2>Profile Picture</h2>

                                    <div className='Upload_wrapper'>
                                        {(localImage || item?.user?.image) &&
                                            <div className='image_preview'>
                                                <ProfilePicture imageUrl={localImage || cdn + item?.user?.image} />
                                            </div>
                                        }
                                        <div className='w-100'>
                                            <Controller name="image" control={control} render={({ field }) =>
                                            (
                                                <UploadButton options={options}
                                                    onComplete={files => {
                                                        const file = files[0];
                                                        setLocalImage(file?.fileUrl);
                                                        field.onChange(file?.originalFile?.file);
                                                    }}>
                                                    {({ onClick }) =>
                                                        <button type='button' onClick={onClick}>
                                                            <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                                                            <span>Upload New</span>
                                                        </button>
                                                    }
                                                </UploadButton>
                                            )}
                                            />
                                            {error?.errors?.image?.map((error) => (
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={error} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>Organization Name *</h2>
                                    <div className='w-100'>
                                        <Controller name="name" control={control} render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' {...field} />} />
                                        {error?.errors?.name?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>Email *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email"  autoComplete="off" name='email'
                                                pattern={
                                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                }
                                                placeholder="Email Address"
                                                {...field}
                                            />} />
                                        {error?.errors?.email?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>Phone</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="phone"
                                            control={control}
                                            render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
                                                type="tel" name='contact' placeholder='Phone number' {...field} />
                                            }
                                        />
                                        {error?.errors?.phone?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary">
                                    <h2>Timezone</h2>
                                    <Controller
                                        name="timezone_id"
                                        control={control}
                                        rules={{ required: "Please select a Timezone" }}
                                        render={({ field }) => (
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                            styles={selectCustomStyles}
                                            value={filterTimezones}
                                            loadOptions={filteredTimezonesLoadOptions}
                                            isClearable
                                            isDisabled={timezoneDisable}
                                            placeholder="Select Timezone"
                                            onChange={(selected) => {
                                                setFilterTimezones(selected);
                                                setValue("timezone_id", selected?.value || "");
                                                field.onChange(selected?.value || "");
                                            }}
                                            additional={{ page: 1 }}
                                            />
                                            {errors?.timezone_id?.message && (
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.timezone_id?.message} />
                                            </div>
                                            )}
                                        </div>
                                        )}
                                    />
                        
                                </div>

                                {/* <div className="row-primary align-items-center">
                                    <h2 className='m-0'>Credentials will be sent over email</h2>
                                    <label className="custom-checkbox checkbox">
                                        <input type="checkbox" name="credentialsSend" checked={credentialsSend === 1 ? true : false} onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div> */}

                                <div className="row-primary align-items-center">
                                    <h2 className='mt-0'>Notifications <span className='opacity-50'>(all type of notification regarding appointments)</span></h2>
                                    <CustomSwitch labelText="notifications" checked={notification == 1 ? true : false} handleChange={(checked) => setNotification(checked ? 1 : 0)} />
                                </div>
                            </div>

                            

                            {/* facilities tag input */}
                            {/* <div className="row-primary">
                                <h2>Facilities</h2>
                                <Controller name="facility_names" control={control} render={({ field }) => <div style={{ width: "100%" }}> <TagInput value={field.value} onChange={(obj) => { field.onChange(obj) }} /> </div>} />
                            </div> */}

                            {/* department tag input */}
                            {/* <div className="row-primary">
                                <h2>Departments</h2>
                                <Controller name="department_names" control={control} render={({ field }) => <div style={{ width: "100%" }}> <TagInput value={field.value} onChange={(obj) => { field.onChange(obj) }} /> </div>} />
                            </div> */}

                            {/* subaccount tag input */}
                            {/* <div className="row-primary">
                                <h2>Sub account</h2>
                                <Controller name="subaccount_names" control={control} render={({ field }) => <div style={{ width: "100%" }}> <TagInput value={field.value} onChange={(obj) => { field.onChange(obj) }} /></div>} />
                            </div> */}

                            {/* Filter area  */}
                            {/* <FilterSwitch
                                setLockStates={setLockStates}
                                item={item}
                                setValue={setValue}
                                lockStates={lockStates}
                                control={control}
                            /> */}

                            {/* Estimated Duration */}
                            {/* <EstimateDurations item={item} /> */}

                            {/* Billing info area  */}
                            <BillingInfo
                                item={item}
                                setfilterStates={setfilterStates}
                                dispatch={dispatch}
                                setAllStates={setAllStates}
                                states={states}
                                control={control}
                                error={error}
                                filterStates={filterStates}
                                allStates={allStates}
                                errors={errors}
                            />

                            {/* dynamic fields */}
                            {/* <div className='dynamic_fields'>
                                <hr />
                                <div className="row-primary row-r justify-content-between flex-row">
                                    <h2>Dynamic Fields </h2>
                                    <SubmitButton btnText='Add' buttonType='button' handleSubmit={handleAdd} />
                                </div>
                                {noOfVariants?.map((variant, index) => renderDynamicField(variant, index))}
                                <hr />
                            </div> */}

                            <div className="Form-footer">
                                <button type='button' className='Cancle_button' onClick={handleCancelEdit}>Cancel</button>
                                <SubmitButton btnText={"Update Profile"} loader={loader} />
                            </div>
                        </form>
                    </FormProvider>
                </div>
            }
            {loader && <FullPageLoader loader={loader} />}
        </div>
    )
}

export default Profile